import { render, staticRenderFns } from "./EdRequest.vue?vue&type=template&id=ef015b3e&"
import script from "./EdRequest.vue?vue&type=script&lang=js&"
export * from "./EdRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports